<template>
	<inertia-head title="Monitoring" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Daily Sales Report</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Monitor daily sales report
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="block block-rounded mb-4">
			<div class="block-content">
				<div class="mb-4">
					<label class="form-label">Choose subscription</label>
					<div class="row">
						<div class="col-md-2">
							<div class="form-check form-block">
								<input
									v-model="tabsub"
									class="form-check-input"
									type="radio"
									id="HOME"
									name="monitoring"
									value="Home"
									checked=""
								/>
								<label class="form-check-label bg-info text-white fw-bold" for="HOME">HOME</label>
							</div>
						</div>
						<div class="col-md-2">
							<div class="form-check form-block">
								<input
									v-model="tabsub"
									class="form-check-input"
									type="radio"
									id="SILVER"
									name="monitoring"
									value="Silver"
								/>
								<label class="form-check-label bg-secondary text-white fw-bold" for="SILVER">SILVER</label>
							</div>
						</div>
						<div class="col-md-2">
							<div class="form-check form-block">
								<input
									v-model="tabsub"
									class="form-check-input"
									type="radio"
									id="GOLD"
									name="monitoring"
									value="Gold"
								/>
								<label class="form-check-label bg-primary text-white fw-bold" for="GOLD">GOLD</label>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-check form-block">
								<input
									v-model="tabsub"
									class="form-check-input"
									type="radio"
									id="DIAMOND"
									name="monitoring"
									value="Diamond"
								/>
								<label class="form-check-label bg-warning text-white fw-bold" for="DIAMOND">DIAMOND</label>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-check form-block">
								<input
									v-model="tabsub"
									class="form-check-input"
									type="radio"
									id="PLATINUM"
									name="monitoring"
									value="Platinum"
								/>
								<label class="form-check-label bg-success text-white fw-bold" for="PLATINUM">PLATINUM</label>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Component -->
		<KeepAlive>
			<component :is="tabsub" :card="card"></component>
		</KeepAlive>
		<div class="block block-rounded">
			<div class="block-content">
				<form @submit.prevent="submit">
					<div class="row">
						<div class="col-md-6">
							<div class="row">
								<div class="col-md-12">
									<div class="form-inline mb-4">
										<label for="date" class="form-label">
											Registration Date
										</label>
										<div class="input-group">
											<flat-pickr
												v-model="form.date"
												id="date"
												class="form-control form-control-sm"
												:config="{
													altInput: true,
													altFormat: 'M j, Y',
													dateFormat: 'Y-m-d',
													wrap: true,
													mode: 'range',
												}"
											/>
											<div class="input-group-append">
												<button @click="viewDate(false)" type="buton" class="btn btn-primary me-2" :disabled="!form.date"><i class="fa fa-check me-1"></i>Display</button>
												<button @click="viewDate(true)" type="buton" class="btn btn-alt-secondary"><i class="fa fa-retweet me-1"></i>Reset</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted,ref,watch } from 'vue'
import {
	Home,
	Silver,
	Gold,
	Diamond,
	Platinum,
} from '../../Components/Admin/Monitoring'
import { Inertia } from '@inertiajs/inertia'
import AuthLayout from '../../Layouts/AuthLayout'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	layout: AuthLayout,
	props: {
		tab: String,
		card: Object,
	},
	components: {
		Home,
		Silver,
		Gold,
		Diamond,
		Platinum,
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const tabsub = ref(props.tab);

		const form = useForm({
			date: null,
		})

		watch(()=>tabsub.value,
			(tab) => {
				Inertia.get(
					route('admin.monitoring.index'),
					{
						tab: tab,
					},
					{
						preserveState: true,
						preserveScroll: true,
						only:['tab,card']
					},
				)
			}
		)

		const viewDate = (reset)=>{
			var date = form.date;

			if(reset)
			{
				date = "";
			}

			Inertia.get(
					route('admin.monitoring.index'),
					{
						tab 	: tabsub.value,
						date 	: date,
					},
					{
						preserveState: true,
						preserveScroll: true,
						only:['tab,card']
					}
				)
		}

		return {
			form,
			tabsub,
			viewDate
		}
	},
}
</script>
